module.exports = __webpack_public_path__ + "img/0-60.d75406d7.jpg";